import React from "react";
import styled, { css } from "styled-components";

import { useOrder } from "src/core/orders/hooks";
import useList from "src/core/lists/hooks/useList";

import { ProductQuantityButton } from "./ProductQuantityButton";
import { ProductPackSizeSelector } from "./ProductPackSizeSelector";
import {
  IProductMaybeWithSubstitution,
  getCurrentListQuantity,
  getCurrentQuantity
} from "../../utils";
import { ProductWithPackSizes } from "../../api/products.api";

interface ProductQuantityControlsProps {
  product: IProductMaybeWithSubstitution;
  orderable?: boolean;
}

export const ProductQuantityControls: React.FC<ProductQuantityControlsProps> = ({ product, orderable }) => {
  const [ { currentOrder } ] = useOrder();
  const [ { currentList } ] = useList();

  const quantity = React.useMemo(() => {
    if (currentList.data) {
      return getCurrentListQuantity(product.id, currentList.data) || null;
    } else {
      if (currentOrder.data) {
        return getCurrentQuantity(product.id, currentOrder.data) || null;
      }
    }

    return null;
  }, [
    product,
    currentList.data,
    currentOrder.data
  ]);

  return (
    <QuantityControlsWrapper>
      <div className="quantity-controls">
        <ProductQuantityButton
          product={product}
        />

        {orderable && quantity && !!product.packSizes?.length && (
          <div className="pack-size-control-wrapper">
            <ProductPackSizeSelector
              product={product as ProductWithPackSizes}
            />
          </div>
        )}
      </div>
    </QuantityControlsWrapper>
  );
};

const QuantityControlsWrapper = styled.div`${({ theme }) => css`
  .pack-size-control-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-top: ${theme.spacing.padding.xs};
  }
`}`;
